import styled from 'styled-components';

export const CountryImage = styled.img`
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;
